module.exports = __webpack_public_path__ + "static/media/truck_large.75c3a380.svg";